import type {
  ModalNoAutorizadoProps,
  UseModalNoAutorizadoReturn,
} from "./types";

export const useModalNoAutorizado = ({
  setVerModalNoautorizado,
}: ModalNoAutorizadoProps): UseModalNoAutorizadoReturn => {
  const handleClose = () => {
    setVerModalNoautorizado(false);
  };

  return {
    handleClose,
  };
};
